import { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Box, Card, Grid } from "@mui/material";
import apiClient from "api-client";
import MDBox from "components/MDBox";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import MDButton from "components/MDButton";
import { backgroundImage, tomarketLogo } from "assets/assets";
import MDInput from "components/MDInput";

const VerifyOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = new URLSearchParams(location.search).get("email");

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);

  const handleChange = (index, value) => {
    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input box
      if (index < 5 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
    } else if (value === "") {
      // Allow deleting by clicking and clearing manually
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      e.preventDefault(); // Prevent default backspace behavior

      const newOtp = [...otp];

      if (otp[index] !== "") {
        // If the current box has a value, clear it first
        newOtp[index] = "";
      } else if (index > 0) {
        // If the current box is empty, move back and clear previous box
        newOtp[index - 1] = "";
        inputRefs.current[index - 1].focus();
      }

      setOtp(newOtp);
    }
  };

  const handlePaste = (e) => {
    const pastedText = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedText)) {
      setOtp(pastedText.split(""));
      inputRefs.current[5].focus();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      toast.error("OTP must be 6 digits.");
      return;
    }

    try {
      const response = await apiClient.post("/auth/verify-otp", { email, otp: enteredOtp });
      console.log(response);
      toast.success("OTP verified successfully!");
      navigate(
        `/reset-password?resetToken=${response.data.resetToken}&email=${encodeURIComponent(email)}`
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || "Invalid OTP.");
    }
  };

  return (
    <BasicLayout image={backgroundImage} formType="verify-otp">
      <Card>
        <MDBox
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          mx={2}
          mt={-3}
          p={2}
          textAlign="center"
        >
          <Grid item xs={12}>
            <Box
              component="img"
              sx={{ width: "80%", maxWidth: "400px", height: "100px", objectFit: "contain" }}
              src={tomarketLogo}
              alt="Logo"
            />
          </Grid>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <Formik initialValues={{}} validationSchema={Yup.object({})} onSubmit={handleSubmit}>
            <Form onSubmit={handleSubmit}>
              <MDBox display="flex" justifyContent="center" gap={1} onPaste={handlePaste}>
                {otp.map((digit, index) => (
                  <MDInput
                    key={index}
                    type="text"
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    inputProps={{ maxLength: 1, style: { textAlign: "center", fontSize: "20px" } }}
                    sx={{ width: "3rem", height: "3rem", textAlign: "center" }}
                  />
                ))}
              </MDBox>

              <MDBox mt={4} mb={1}>
                <MDButton type="submit" variant="gradient" color="success" fullWidth>
                  Verify OTP
                </MDButton>
              </MDBox>
            </Form>
          </Formik>
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default VerifyOTP;
